import { render } from "./StudentForm.vue?vue&type=template&id=76e9b03b&scoped=true"
import script from "./StudentForm.vue?vue&type=script&lang=js"
export * from "./StudentForm.vue?vue&type=script&lang=js"

import "./StudentForm.vue?vue&type=style&index=0&id=76e9b03b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76e9b03b"]])

export default __exports__